import styled from 'styled-components';

import { wz, wzType } from '../wizardStyles';

// 6778:18434 `line`: a sentence row, 11 between its parts and 11 above and below; 58.4 tall with
// an input in it.
export const Line = styled.div<{ $dim?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 41px;
  padding: 11px 0;
  opacity: ${({ $dim }) => ($dim ? 0.45 : 1)};

  > * + * {
    margin-left: 11px;
  }
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
`;

/** Lead-in and unit copy; an answered or checked line reads in the primary ink. */
export const Words = styled.span<{ $muted?: boolean }>`
  color: ${({ $muted }) => ($muted ? wz.secondary : wz.text)};
  ${wzType.body}
`;

export const Hint = styled.span`
  color: ${wz.muted};
  ${wzType.hint}
`;

// 6778:18458 `sub`: rows nested under a checked line, 33 in.
export const Sub = styled.div`
  padding-left: 33px;
`;

// 6778:18460: the schedule's label column (x 505) and control column (x 688.8).
export const FieldRow = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 7px 0;

  > :first-child {
    flex: 0 0 172px;
    padding-top: 7px;
  }
`;

export const Divider = styled.hr`
  height: 0;
  margin: 12px 0;
  border: 0;
  border-top: 1px solid ${wz.border};
`;

// 6778:20275 `rulecard`: r12 on the field fill, 21 in.
export const Card = styled.div`
  position: relative;
  padding: 18px 21px 12px;
  border: ${wz.line} solid ${wz.border};
  border-radius: 12px;
  background: ${wz.field};

  & + & {
    margin-top: 12px;
  }
`;

export const Eyebrow = styled.h3`
  margin: 0 0 4px;
  color: ${wz.muted};
  font-weight: 800;
  text-transform: uppercase;
  ${wzType.eyebrow}
`;

export const ErrorList = styled.ul`
  margin: 16px 0 0;
  padding: 0;
  list-style: none;
  color: ${wz.danger};
  ${wzType.label}

  > li + li {
    margin-top: 4px;
  }
`;
